module.exports = __webpack_public_path__ + "img/mvp_girl_2022.10580e3d.webp";